import FilStorage from './FilStorage';

class StoreManager {
  constructor() {
    this.browserStorage = new FilStorage();
    this.isBrowserStorageEnabled = this.browserStorage.isStorageEnabled;
  }
  save(key, value) {
    if (this.isBrowserStorageEnabled) {
      this.browserStorage.setSessionItem(key, value);
    } else {
      console.log(key);
      window.key = value;
    }
  }

  retrieve(key) {
    if (this.isBrowserStorageEnabled) {
      return this.browserStorage.getSessionItem(key);
    }
    return window.key;
  }

  remove(key) {
    if (this.isBrowserStorageEnabled) {
      this.browserStorage.removeSessionItem(key);
    }
    window.key = null;
  }
}

const storeManager = new StoreManager();

export default storeManager;



// WEBPACK FOOTER //
// ./src/lib/StorageManager.js